<template>
    <div class="filters">
        <div class="card">
            <div class="card-header">
                <h3 class="card-title">Liste des categories</h3>
                <div class="card-options">
                    <a href="#" class="btn btn-primary btn-sm hide">Exporter</a>
                    <a href="#" class="btn btn-secondary btn-sm ml-2 hide">Importer</a>
                </div>
            </div>
            <el-form ref="filtersForm" :model="filters" label-position="top">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <el-form-item prop="manufacturer_id" label="Fournisseurs">
                                <el-select clearable v-model="filters.manufacturer_id" placeholder="Fournisseurs" filterable>
                                    <el-option v-for="item in manufacturersOptions" :key="item.id" :label="item.name" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-3">
                            <el-form-item prop="product_search" label="Rechercher des produits">
                                <el-input clearable v-model="filters.product_search" placeholder="Rechercher des produits" />
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="pull-left">
                        <el-dropdown split-button @command="applyAction">
                            Actions groupées
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="item.value" v-for="(item, index) in groupedActionsOptions" :key="index">{{item.label}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-checkbox v-model="applyToAllResult">Appliquer à tous les résultats</el-checkbox>

                    </div>
                    <div class="pull-right">
                        <el-button @click="resetFilters" type="info" plain>Annuler</el-button>
                        <el-button @click="validFilters" type="primary">Valider</el-button>
                    </div>
                </div>
            </el-form>
        </div>

        <el-dialog title="Activer / Désactiver" v-loading="modal.activate_desactivate.loader" :visible.sync="modal.activate_desactivate.display" width="50%">
            <span>Activer / Désactiver les {{ items_selected }} categories selectionnés</span>
            <el-form class="row formActive" ref="formActivateDesactivate" :model="modal.activate_desactivate.form">
                <el-form-item prop="activated">
                    <el-switch v-model="modal.activate_desactivate.form.activated" active-text="Activé" inactive-text="Désactivé">
                    </el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modal.activate_desactivate.display = false">Annuler</el-button>
                <el-button type="primary" @click="changeActivateDesactivate">Enregistrer</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Activer / Désactiver le vehiculier" v-loading="modal.activate_desactivate_vehiculier.loader" :visible.sync="modal.activate_desactivate_vehiculier.display" width="50%">
            <span>Activer / Désactiver les {{ items_selected }} categories selectionnés</span>
            <el-form class="row formActive" ref="formActivateDesactivateVehiculier" :model="modal.activate_desactivate_vehiculier.form">
                <el-form-item prop="activated">
                    <el-switch v-model="modal.activate_desactivate_vehiculier.form.activated" active-text="Activé" inactive-text="Désactivé">
                    </el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modal.activate_desactivate_vehiculier.display = false">Annuler</el-button>
                <el-button type="primary" @click="changeActivateDesactivateVehiculier">Enregistrer</el-button>
            </span>
        </el-dialog>


    </div>
</template>
<script>
import { EventBus } from '../../event-bus';

export default {
    data() {
        return {
            brandsOptions: [],
            categoriesOptions: [],
            manufacturersOptions: [],
            filters: {
                brand_id: '',
                manufacturer_id: '',
                category_id: [],
                queryAutocomplete: null,
                product_search: null,
            },
            groupedActionsOptions: [
                {
                    label: 'Activer / Désactiver',
                    value: 'activate_desactivate'
                },
                {
                    label: 'Synchroniser',
                    value: 'synchronize'
                },
                {
                    label: 'Activer / Désactiver le vehiculier',
                    value: 'activate_desactivate_vehiculier'
                }
            ],
            groupedActionsValue: '',
            rules: {
                name: [
                    {
                        required: true,
                        message: 'Veuillez renseignez un nom',
                        trigger: 'blur'
                    }
                ],
                categories: [
                    {
                        required: true,
                        message: 'Veuillez choisir une catégorie parente',
                        trigger: 'blur'
                    },
                ],
                shop_id: [
                    {
                        required: true,
                        message: 'Veuillez renseigner un ShopId',
                        trigger: 'blur'
                    },
                ],
            },
            modal: {
                activate_desactivate: {
                    display: false,
                    loader: false,
                    form: {
                        activated: false
                    }
                },
                activate_desactivate_vehiculier: {
                    display: false,
                    loader: false,
                    form: {
                        activated: false
                    }
                },
                createEditCategory: {
                    display: false,
                    loader: false,
                    form: {
                        categories: [],
                        activated: true
                    }
                }
            }
        };
    },
    props: {
        selected: {
            default() {
                return [];
            }
        }
    },
    computed: {
        q: {
            get() {
                return this.$store.getters['app/q'];
            },
            set(value) {
                this.$store.dispatch('app/setQ', value);
            }
        },
        total_item() {
            return this.$store.getters['categories/totalItems'];
        },
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
        applyToAllResult: {
            get() {
                return this.$store.getters['categories/applyToAllResults'];
            },
            set(value) {
                this.$store.dispatch('categories/setApplyToAllResults', value);
            }
        }
    },
    mounted() {
        axios.get('/manufacturers').then(r => {
            this.manufacturersOptions = r.data.data;
        });

        EventBus.$on('search-input.submit', () => {
            this.validFilters();
        });
    },
    methods: {

        resetFilters() {
            this.$refs.filtersForm.resetFields();
            this.$store.dispatch('app/setQ', null);
            this.validFilters();
        },

        validFilters() {
            var filters = {};
            this.filters.q = this.q;
            var exclude = ['applyToAllResult'];
            for (let filter in this.filters) {
                if (
                    this.filters[filter] != '' &&
                    this.filters[filter] !== null &&
                    exclude.indexOf(filter) == -1
                ) {
                    filters[filter] = this.filters[filter];
                }
            }
            this.$emit('update-filters', filters);
        },
        setFilter(filter_name, value, noValidate) {
            this.filters[filter_name] = value;
            if (!noValidate) {
                this.validFilters();
            }
        },
        applyAction(v) {
            if (!this.selected.length && !this.applyToAllResult) return;
            switch (v) {
                case 'activate_desactivate':
                    this.modal.activate_desactivate.display = true;
                    break;
                case 'activate_desactivate_vehiculier':
                    this.modal.activate_desactivate_vehiculier.display = true;
                    break;
                default:
                    break;
            }
        },

        changeActivateDesactivate() {
            var activated = this.modal.activate_desactivate.form.activated;
            var categories = this.selected.map(v => v.id);
            this.modal.activate_desactivate.loader = true;
            var datas = {
                categories,
                activated,
                mode: 'activate_desactivate'
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            axios
                .post('/categories/bulk', datas)
                .then(r => {
                    this.$emit(
                        'categoriesUpdated',
                        Category.build(r.data.data)
                    );
                    this.$refs.formActivateDesactivate.resetFields();
                    this.modal.activate_desactivate.display = false;
                    this.applyToAllResult = false;
                })
                .catch(() => {})
                .then(() => {
                    this.modal.activate_desactivate.loader = false;
                });
        },

        changeActivateDesactivateVehiculier() {
            var activated = this.modal.activate_desactivate_vehiculier.form
                .activated;
            var categories = this.selected.map(v => v.id);
            this.modal.activate_desactivate_vehiculier.loader = true;
            var datas = {
                categories,
                activated,
                mode: 'activate_desactivate_vehiculier'
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            axios
                .post('/categories/bulk', datas)
                .then(r => {
                    this.$emit('categoriesUpdated', r.data.data);
                    this.$refs.formActivateDesactivateVehiculier.resetFields();
                    this.modal.activate_desactivate_vehiculier.display = false;
                    this.applyToAllResult = false;
                })
                .catch(() => {})
                .then(() => {
                    this.modal.activate_desactivate_vehiculier.loader = false;
                });
        }
    }
};
</script>
<style lang="scss">
.el-form {
    .card-footer {
        text-align: initial;
        .pull-right {
            text-align: center;
        }
    }
}
</style>
